import * as React from 'react';
import * as styles from './styles.css';

export function Main({ children }: React.PropsWithChildren<{}>) {
  return (
    <div data-nav-tab="start/Главная" id="start" className={styles['container']}>
      {children}
    </div>
  );
}
